import { axios } from '@axios';
import { useQuery, useMutation, MutationOptions } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from '../../lib/react-query';

export const getVapiKeys = (params?: any): Promise<any> => {
  return axios.get('/admin/vapi-keys', { params });
};


export const toggleVapiKeyStatus = ({ keyId }: { keyId: number }): Promise<any> => {
  return axios.patch(`/admin/vapi-keys/${keyId}/toggle-status`);
};

export const deleteVapiKey = ({ keyId }: { keyId: string }): Promise<any> => {
  return axios.delete(`/admin/vapi-keys/${keyId}`);
};

export const createVapiKey = (data: any): Promise<any> => {
  return axios.post('/admin/vapi-keys', data);
};

export const updateVapiKey = ({ environment, data }: { environment: string; data: any }): Promise<any> => {
  return axios.patch(`/admin/vapi-keys/${environment}`, data);
};

type QueryFnType = typeof getVapiKeys;

export const useVapiKeysQuery = ({ params, config }: { params?: any; config?: QueryConfig<QueryFnType> } = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['vapiKeys', params],
    queryFn: () => getVapiKeys(params),
    select: (res: any) => res,
    ...config,
  });
};


export const useToggleVapiKeyStatusMutation = (
  options?: MutationOptions<Awaited<ReturnType<typeof toggleVapiKeyStatus>>, unknown, Parameters<typeof toggleVapiKeyStatus>[0]>
) => {
  return useMutation<Awaited<ReturnType<typeof toggleVapiKeyStatus>>, unknown, Parameters<typeof toggleVapiKeyStatus>[0]>({
    mutationFn: toggleVapiKeyStatus,
    ...options,
  });
};

export const useDeleteVapiKeyMutation = (
  options?: MutationOptions<Awaited<ReturnType<typeof deleteVapiKey>>, unknown, Parameters<typeof deleteVapiKey>[0]>
) => {
  return useMutation<Awaited<ReturnType<typeof deleteVapiKey>>, unknown, Parameters<typeof deleteVapiKey>[0]>({
    mutationFn: deleteVapiKey,
    ...options,
  });
};

export const useCreateVapiKeyMutation = (
  options?: MutationOptions<Awaited<ReturnType<typeof createVapiKey>>, unknown, Parameters<typeof createVapiKey>[0]>
) => {
  return useMutation<Awaited<ReturnType<typeof createVapiKey>>, unknown, Parameters<typeof createVapiKey>[0]>({
    mutationFn: createVapiKey,
    ...options,
  });
};

export const useUpdateVapiKeyMutation = (
  options?: MutationOptions<Awaited<ReturnType<typeof updateVapiKey>>, unknown, Parameters<typeof updateVapiKey>[0]>
) => {
  return useMutation<Awaited<ReturnType<typeof updateVapiKey>>, unknown, Parameters<typeof updateVapiKey>[0]>({
    mutationFn: updateVapiKey,
    ...options,
  });
};